export const REF_PARAM = "ref"

const REFERRAL_CODE_PATTERN = /^[A-Z0-9][A-Z0-9-]{2,31}$/

const REF_STORED_AT = "ref_at"

export const REF_TTL_MS = 30 * 24 * 60 * 60 * 1000

export const normalizeReferralCode = (raw: string | null | undefined): string | null => {
  const candidate = raw?.trim().toUpperCase() ?? ""
  return REFERRAL_CODE_PATTERN.test(candidate) ? candidate : null
}

const utmParams = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "utm_checkout_type", "utm_web_to_app", "utm_pseudo_id", "utm_ad", "utm_id", REF_PARAM]

export const storeRef = (code: string) => {
  localStorage.setItem(REF_PARAM, code)
  localStorage.setItem(REF_STORED_AT, String(Date.now()))
}

export const clearRef = () => {
  localStorage.removeItem(REF_PARAM)
  localStorage.removeItem(REF_STORED_AT)
}

export const readRef = (): string | null => {
  const stored = localStorage.getItem(REF_PARAM)
  if (stored === null) return null
  const code = normalizeReferralCode(stored)
  const storedAt = Number(localStorage.getItem(REF_STORED_AT))
  if (code && storedAt > 0 && Date.now() - storedAt < REF_TTL_MS) return code
  clearRef()
  return null
}

export const persistUTMParams = () => {
  if (typeof window !== "undefined") {
    const urlParams = new URLSearchParams(window.location.search)

    utmParams.forEach((param) => {
      if (param === REF_PARAM) return
      const value = urlParams.get(param)
      if (value) localStorage.setItem(param, value)
    })
  }
}

export const retrieveUTMParams = () => {
  if (typeof window !== "undefined") {
    const params: { [key: string]: string } = {}
    utmParams.forEach((param) => {
      const value = param === REF_PARAM ? readRef() : localStorage.getItem(param)
      if (value) {
        params[param] = value
      }
    })
    return params
  }
  return undefined
}
